import { useMemo } from 'react';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';

export const useStatusRender = () => {
  return useMemo(() => {
    return (status: number | boolean) => {
      const isActive = status === 1 || status === true;

      if (isActive) {
        return {
          icon: <CheckCircleOutlined />,
          text: 'Active',
          color: '#52c41a',
          bgColor: '#f6ffed',
          textColor: '#52c41a',
          borderColor: '#b7eb8f',
        };
      }

      return {
        icon: <StopOutlined />,
        text: 'Inactive',
        color: '#ff4d4f',
        bgColor: '#fafafa',
        textColor: '#000000e0',
        borderColor: '#d9d9d9',
      };
    };
  }, []);
};
